export default {
  // Visible en Ajustes > Apps > Binnacle > Notificaciones, como nombre del canal del sistema.
  channelName: 'Avisos de Binnacle',
  channelDescription: 'Tareas asignadas, auditorías finalizadas y avisos de la operación',
  // TKT-2149: aviso de ubicacion simulada en la campanita
  mock_user: 'Usuario',
  mock_location: 'Ubicación',
  mock_activity: 'Actividad',
  mock_detected_at: 'Fecha y hora',
  mock_result: 'Resultado'
}
